import { createContext } from "react";

//#region "App config context"
export const AppConfig = createContext({
  featureFlags: {
    disableTableSort: true,
  },
  config: {
    baseUrl: "",
    baseAppUrl: "",
    baseDeviceUrl: "",
    baseStorageUrl: "",
    token: "",
    tenantId: "",
    language: "",
    configBrand: "",
    productCode: "",
    appRegionId: ""
  },
  setConfig: (config: any) => {},
  userProfile: {
    email: "",
    emailVerified: "",
    lastname: "",
    firstname: "",
    username: "",
    id: "",
    locale: "",
    role: "",
    
   
  },
  userLegal: {
    licenseAccept: false,
    legalApps: []
  },
  availableFeatures: [] as string[],
  setUserLegal: (userLegal: any) => {},
  setUserProfile: (userProfile: any) => {},
  updateUserLocale: (locale: string) => {},
  setAvailableFeatures: (features: string[]) => {},
  applicationFeatures: [] as any[],
  setApplicationFeatures: (features: any[]) => {},
  subscribedApps: [] as string[],
  setSubscribedApps: (features: string[]) => {},
  allApps: [] as any[], 
  setAllAps: (allApps: any[]) => {},
  userAccessApps: [] as any[], 
  setUserAccessApps: (userAccessApps: any[]) => {},
  availableApps: [] as any[], 
  setAvailableApps: (availableApps: any[]) => {}
});
//#endregion
